import React from 'react';
import { Box, Typography } from '@mui/material';

const WelcomeHeader = ({
  title = "Agente de Pr\u00e9 Venda",
  subtitle = "Gerencie seus leads com praticidade e inteligência.",
  gradient = 'linear-gradient(135deg, #41B28E 0%, #24695B 100%)', // TORNAR DINÂMICO - CV
  textAlign = { xs: 'center', md: 'left' },
  ...props
}) => {
  const isCvcrmBrand =
    typeof window !== 'undefined' &&
    localStorage.getItem('brand') === 'cvcrm';

  const effectiveGradient = isCvcrmBrand
    ? 'linear-gradient(135deg, #41B28E 0%, #24695B 100%)' // CVCRM
    : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'; // Tema padrão

  return (
    <Box
      sx={{
        background: effectiveGradient,
        borderRadius: { xs: 3, md: 4 },
        p: { xs: 1.5, sm: 2, md: 2.5 },
        mb: { xs: 1.5, md: 2 },
        color: 'white',
        position: 'relative',
        textAlign: textAlign,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.3,
        },
        ...props.sx,
      }}
      {...props}
    >
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 540,
            fontSize: { xs: '1rem', sm: '1.125rem', md: '1.09rem' },
            lineHeight: 1.1,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="body2"
            sx={{
              opacity: 0.9,
              fontWeight: 300,
              fontSize: { xs: '0.8rem', sm: '0.875rem', md: '1rem' },
              lineHeight: 1.3,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default WelcomeHeader;
